/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Match_Both14Inputs */

const en__field_enum_icsrm_match_both14 = /** @type {(inputs: _Field_Enum_Icsrm_Match_Both14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`both`)
};

const de__field_enum_icsrm_match_both14 = /** @type {(inputs: _Field_Enum_Icsrm_Match_Both14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`beides`)
};

/**
* | output |
* | --- |
* | "both" |
*
* @param {_Field_Enum_Icsrm_Match_Both14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_match_both14 = /** @type {((inputs?: _Field_Enum_Icsrm_Match_Both14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Match_Both14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_match_both14(inputs)
	return de__field_enum_icsrm_match_both14(inputs)
});
export { _field_enum_icsrm_match_both14 as "_field_enum_ICSRM_MATCH_BOTH" }